
export function BookingCTA() {
  return (
    <section id="booking" className="py-24 bg-gradient-to-br from-amber-700 via-amber-800 to-green-800">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-white/20 mx-auto mb-6">
          <i className="ri-calendar-check-line text-white text-3xl"></i>
        </div>
        <h2 className="font-display text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          Book Your Free
          <br />
          30-Minute Consultation
        </h2>
        <p className="font-body text-lg text-white/90 mb-10">
          Start your journey with Lotus Maternal — no pressure, just a warm conversation about your needs.
        </p>

        <a
          href="https://calendly.com/queenbriebirthworker/30min"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-12 py-5 bg-white text-amber-800 font-body font-bold text-lg rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-calendar-line text-xl"></i>
          Schedule My Free Consultation
        </a>

        <div className="flex flex-wrap justify-center gap-8 mt-14">
          <div className="flex items-center gap-3 text-white">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-vidicon-line text-xl"></i>
            </div>
            <span className="font-body text-sm">Zoom</span>
          </div>
          <div className="flex items-center gap-3 text-white">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-phone-line text-xl"></i>
            </div>
            <span className="font-body text-sm">Virtual</span>
          </div>
          <div className="flex items-center gap-3 text-white">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-home-heart-line text-xl"></i>
            </div>
            <span className="font-body text-sm">In-Person</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BookingCTA;
